import React from "react";

const SectionWrapper = ({ children }) => {
  return <div className="w-[370px] lg:w-[1560px] mx-auto">{children}</div>;
};

export default SectionWrapper;
